export const common = {
  // Navigation
  home: 'الرئيسية',
  product: 'المنتج',
  applications: 'التطبيقات',
  aboutUs: 'من نحن',
  contact: 'اتصل بنا',
  
  // Common Actions
  learnMore: 'اعرف المزيد',
  getStarted: 'ابدأ',
  contactUs: 'اتصل بنا',
  sendMessage: 'إرسال رسالة',
  sending: 'جاري الإرسال...',
  
  // Footer
  quickLinks: 'روابط سريعة',
  ourProduct: 'منتجنا',
  followUs: 'تابعنا',
  poweredBy: 'مدعوم من Readdy',
  allRightsReserved: 'جميع الحقوق محفوظة.',
  footerDescription: 'التميز الهندسي في تعزيز ألياف الصلب لصناعة البناء.',
  hookedEndSteelFibers: 'ألياف الصلب ذات النهاية المعقوفة',
  websiteBuilder: 'منشئ الموقع',
  
  // Contact
  address: 'العنوان',
  phone: 'الهاتف',
  email: 'البريد الإلكتروني',
  whatsapp: 'واتساب',
  instagram: 'إنستغرام',
  
  // Form
  fullName: 'الاسم الكامل',
  companyName: 'اسم الشركة',
  emailAddress: 'عنوان البريد الإلكتروني',
  phoneNumber: 'رقم الهاتف',
  message: 'الرسالة',
  required: '*',
  characters: 'حرف',
  
  // Messages
  successMessage: 'شكراً لك! تم إرسال رسالتك بنجاح. سنعود إليك قريباً.',
  errorMessage: 'عذراً، حدث خطأ أثناء إرسال رسالتك. يرجى المحاولة مرة أخرى أو الاتصال بنا مباشرة.',
};

